<template>
    <FormSection title="Demographics Information" type="his-section" :full-height="false" :application-id="application">
        <template #content>
            <section class="py-3 pb-0 g-0">
                <div class="col-12 px-4 g-0">
                    <div class="col-12 py-2">
                        <div class="w-100">
                            <p class="mb-2 d-flex align-items-center sub-heading">
                                <b class="me-2">Patient Information</b>
                            </p>
                        </div>
                        <div class="row">
                            <div class="form-group col-12 col-lg-5 pe-lg-2">
                                <label id="patient_mrn" for="paient_mrn">
                                    Patient ID/MR Number
                                    <span class="text-danger">*</span>
                                </label>
                                <input
                                    id="patient_mrn"
                                    name="patient_mrn"
                                    class="form-control"
                                    maxlength="50"
                                    type="text"
                                    placeholder="Enter MRN"
                                    v-model="patientDetails.demographics.medicalRecordNumber"
                                    @blur="v$.patientDetails.demographics.medicalRecordNumber.$touch"
                                    :class="`${
                                        v$.patientDetails.demographics.medicalRecordNumber.$error ? 'field-invalid' : ''
                                    }`"
                                    @change="(e) => handleAllInput(e, 'medicalRecordNumber')"
                                />
                                <span
                                    v-if="v$.patientDetails.demographics.medicalRecordNumber.$error"
                                    class="field-invalid"
                                >
                                    Patient ID/MR Number is required.</span
                                >
                            </div>
                            <div class="col-5 mt-4 pt-1">
                                <i> Last Patient ID/MR Number Used: KC07182024</i>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label id="Referral_First_Name_Label" for="referral-first-name">
                                    First Name
                                    <span class="text-danger">*</span>
                                </label>
                                <input
                                    id="Referral_First_Name"
                                    name="referral-first-name"
                                    maxlength="50"
                                    type="text"
                                    placeholder="Enter First Name"
                                    class="form-control"
                                    v-model="patientDetails.demographics.firstName"
                                    @blur="v$.patientDetails.demographics.firstName.$touch"
                                    :class="`${v$.patientDetails.demographics.firstName.$error ? 'field-invalid' : ''}`"
                                    @change="(e) => handleAllInput(e, 'firstName')"
                                />
                                <span v-if="v$.patientDetails.demographics.firstName.$error" class="field-invalid"
                                    >First Name is required.</span
                                >
                            </div>

                            <div class="form-group col-4 col-lg-3 pe-lg-2">
                                <label for="referral-middle-initial"> Middle Name </label>
                                <input
                                    name="referral-middle-initial"
                                    class="form-control"
                                    maxlength="100"
                                    type="text"
                                    placeholder="Enter Middle Name"
                                    v-model="patientDetails.demographics.middleName"
                                />
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label id="Referral_Last_Name_Label" for="referral-last-name">
                                    Last Name
                                    <span class="text-danger">*</span>
                                </label>
                                <input
                                    id="Referral_Last_Name"
                                    name="referral-last-name"
                                    class="form-control"
                                    maxlength="50"
                                    placeholder="Enter Last Name"
                                    type="text"
                                    v-model="patientDetails.demographics.lastName"
                                    @blur="v$.patientDetails.demographics.lastName.$touch"
                                    :class="`${v$.patientDetails.demographics.lastName.$error ? 'field-invalid' : ''}`"
                                    @change="(e) => handleAllInput(e, 'lastName')"
                                />
                                <span v-if="v$.patientDetails.demographics.lastName.$error" class="field-invalid"
                                    >Last Name is required.</span
                                >
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label id="Referral_suffix_Label" for="referral-suffix"> Suffix </label>
                                <input
                                    id="Referral_suffix"
                                    name="referral-suffix"
                                    class="form-control"
                                    maxlength="50"
                                    placeholder="Enter Suffix"
                                    type="text"
                                    v-model="patientDetails.demographics.suffix"
                                />
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label for="dateOfBirth">
                                    Date of Birth
                                    <span class="text-danger">*</span>
                                </label>
                                <DatePicker :getDate="onDateChange">
                                    <div class="input-group date datepickerInput">
                                        <input
                                            name="dateOfBirth"
                                            type="text"
                                            class="form-control"
                                            placeholder="MM/DD/YYYY"
                                            autocomplete="off"
                                            :value="formatDateInput(patientDetails.demographics.dateOfBirth)"
                                            @change="handleDateInputChange"
                                            @blur="v$.patientDetails.demographics.dateOfBirth.$touch"
                                            :class="`${
                                                v$.patientDetails.demographics.dateOfBirth.$error ? 'field-invalid' : ''
                                            }`"
                                        />
                                        <div class="input-group-addon input-group-append">
                                            <div class="input-group-text">
                                                <i class="fa fa-calendar"></i>
                                            </div>
                                        </div>
                                        <span
                                            v-if="v$.patientDetails.demographics.dateOfBirth.$error"
                                            class="field-invalid"
                                            >Date of Birth is required.</span
                                        >
                                    </div>
                                </DatePicker>
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label id="Referral_Gender_Label" for="referral-gender">
                                    Sex
                                    <span class="text-danger">*</span>
                                </label>
                                <select
                                    id="Referral_Gender"
                                    class="form-select"
                                    name="referral-gender"
                                    v-model="patientDetails.demographics.gender"
                                    @blur="v$.patientDetails.demographics.gender.$touch"
                                    :class="`${v$.patientDetails.demographics.gender.$error ? 'field-invalid' : ''}`"
                                    @change="(e) => handleAllInput(e, 'gender')"
                                >
                                    <option :value="0">Select Sex</option>
                                    <option v-for="value of Genders" :value="value.value" :key="value">
                                        {{ value.name }}
                                    </option>
                                </select>
                                <span v-if="v$.patientDetails.demographics.gender.$error" class="field-invalid"
                                    >Sex is required.</span
                                >
                            </div>

                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label id="Referral_Gender_Identity_Label" for="referral-gender-identity">
                                    Sex Identity
                                </label>
                                <select
                                    id="Referral_Gender_Identity"
                                    class="form-select"
                                    name="referral-gender-identity"
                                    v-model="patientDetails.demographics.genderIdentity"
                                >
                                    <option :value="0">Select Sex Identity</option>
                                    <option v-for="[key, value] of GenderIdentities" :value="value.value" :key="key">
                                        {{ value.name }}
                                    </option>
                                </select>
                            </div>
                            <div
                                class="form-group col-12 col-lg-3 pe-lg-2"
                                v-if="patientDetails.demographics.genderIdentity === 6"
                            >
                                <label id="Referral_Other_Gender_Identity_Label" for="referral-other-gender-identity">
                                    Please specify
                                    <span class="text-danger">*</span>
                                </label>
                                <input
                                    id="Referral_Other_Gender_Identity"
                                    name="referral-other-gender-identity"
                                    class="form-control"
                                    maxlength="255"
                                    type="text"
                                    v-model="patientDetails.demographics.otherGenderIdentity"
                                    @blur="v$.patientDetails.demographics.otherGenderIdentity.$touch"
                                    :class="`${
                                        v$.patientDetails.demographics.otherGenderIdentity.$error ? 'field-invalid' : ''
                                    }`"
                                    @change="(e) => handleAllInput(e, 'otherGenderIdentity')"
                                />
                                <span
                                    v-if="v$.patientDetails.demographics.otherGenderIdentity.$error"
                                    class="field-invalid"
                                    >OtherGenderIdentity is required.</span
                                >
                            </div>

                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label id="Referral_Sexual_Orientation_Label" for="referral_sexual_orientation">
                                    Sexual Orientation
                                </label>
                                <select
                                    id="Referral_Sexual_Orientation"
                                    class="form-select"
                                    name="referral_sexual_orientation"
                                    v-model="patientDetails.demographics.sexualOrientation"
                                >
                                    <option :value="0">Select Sexual Orientation</option>
                                    <option v-for="[key, value] of SexualOrientation" :value="value.value" :key="key">
                                        {{ value.name }}
                                    </option>
                                </select>
                            </div>
                            <div
                                class="form-group col-12 col-lg-3 pe-lg-2"
                                v-if="patientDetails.demographics.sexualOrientation === 4"
                            >
                                <label
                                    id="Referral_Other_Sexual_Orientation_Label"
                                    for="referral-other-sexual-orientation"
                                >
                                    Please specify
                                    <span class="text-danger">*</span>
                                </label>
                                <input
                                    id="Referral_Other_Sexual_Orientation"
                                    name="referral-other-sexual-orientation"
                                    class="form-control"
                                    maxlength="255"
                                    type="text"
                                    v-model="patientDetails.demographics.otherSexualOrientation"
                                    @blur="v$.patientDetails.demographics.otherSexualOrientation.$touch"
                                    :class="`${
                                        v$.patientDetails.demographics.otherSexualOrientation.$error
                                            ? 'field-invalid'
                                            : ''
                                    }`"
                                    @change="(e) => handleAllInput(e, 'otherSexualOrientation')"
                                />
                                <span
                                    v-if="v$.patientDetails.demographics.otherSexualOrientation.$error"
                                    class="field-invalid"
                                    >Other Sexual Orientation is required.</span
                                >
                            </div>

                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label for="referral-social-security-number"> Social Security Number </label>
                                <span>
                                    <div class="input-group d-flex w-100 flex-nowrap">
                                        <div class="flex-grow-1">
                                            <input
                                                name="referral-social-security-number"
                                                maxlength="9"
                                                minlength="9"
                                                class="form-control"
                                                type="text"
                                                placeholder="Enter SSN"
                                                v-number-only
                                                v-model="patientDetails.demographics.socialSecurityNumber"
                                                @blur="v$.patientDetails.demographics.socialSecurityNumber.$touch"
                                                :class="`${
                                                    v$.patientDetails.demographics.socialSecurityNumber.$error
                                                        ? 'field-invalid'
                                                        : ''
                                                }`"
                                                @change="(e) => handleAllInput(e, 'socialSecurityNumber')"
                                            />
                                            <span
                                                v-if="v$.patientDetails.demographics.socialSecurityNumber.$error"
                                                class="field-invalid"
                                                >{{
                                                    v$.patientDetails.demographics.socialSecurityNumber.$errors[0]
                                                        .$message
                                                }}</span
                                            >
                                        </div>
                                    </div>
                                </span>
                            </div>
                            <div class="form-group col-4 col-lg-2 pe-lg-2">
                                <label for="referral-veteran"> Veteran </label>
                                <div class="input-group d-flex w-100 flex-nowrap">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text form-check p-1 pb-2">
                                            <input
                                                type="checkbox"
                                                class="form-check-input mx-1"
                                                id="veteran"
                                                v-model="isVeteranSelected"
                                            />
                                            <label class="form-check-label" for="veteran"></label>
                                        </div>
                                    </div>
                                    <div class="flex-shrink-1 flex-grow-1">
                                        <MultiSelectDropdown
                                            :disabled="!isVeteranSelected"
                                            :options="veteranOptions"
                                            :selected-items="patientDetails.demographics.veteran"
                                            v-on:selectedItemsUpdated="selectedItemsUpdated"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="w-100"></div>
                            <div class="form-group col-12 col-lg-4 pe-lg-2">
                                <label for="referral-mobile-number">
                                    Primary Phone Number
                                    <i
                                        class="fas fa-question-circle"
                                        v-tooltip="{
                                            title: `For emergency preparedness, patient will be contacted at this number. This will also populate to the emergency preparedness report.`
                                        }"
                                    ></i>
                                    <span class="text-danger">*</span>
                                </label>
                                <PhoneNumber
                                    :enable-country="true"
                                    v-model:value="primaryNumber"
                                    v-model:extension="primaryExtension"
                                    v-model:type="primaryType"
                                    v-model:country="primaryCountry"
                                    :phone-type-options="phoneNumberTypeOptionsConfig"
                                    v-number-only
                                    v-on:blurredInput="
                                        v$.patientDetails.demographics.phoneNumbers[
                                            primaryNumberIndex(patientDetails.demographics?.phoneNumbers)
                                        ].$touch()
                                    "
                                    :class="`${
                                        v$.patientDetails.demographics.phoneNumbers[
                                            primaryNumberIndex(patientDetails.demographics?.phoneNumbers)
                                        ]?.number.$error ||
                                        v$.patientDetails.demographics.phoneNumbers[
                                            primaryNumberIndex(patientDetails.demographics?.phoneNumbers)
                                        ]?.type.$error
                                            ? 'field-invalid'
                                            : ''
                                    }`"
                                />
                                <span
                                    v-if="
                                        v$.patientDetails.demographics.phoneNumbers[
                                            primaryNumberIndex(patientDetails.demographics.phoneNumbers)
                                        ]?.number.$error &&
                                        v$.patientDetails.demographics.phoneNumbers[
                                            primaryNumberIndex(patientDetails.demographics?.phoneNumbers)
                                        ]?.type.$error
                                    "
                                    class="field-invalid"
                                    >Phone Number and Phone Type is required.</span
                                >
                                <span
                                    v-else-if="
                                        v$.patientDetails.demographics.phoneNumbers[
                                            primaryNumberIndex(patientDetails.demographics.phoneNumbers)
                                        ]?.number.$error
                                    "
                                    class="field-invalid"
                                    >Phone Number is required.
                                </span>
                                <span
                                    v-else-if="
                                        v$.patientDetails.demographics.phoneNumbers[
                                            primaryNumberIndex(patientDetails.demographics?.phoneNumbers)
                                        ]?.type.$error
                                    "
                                    class="field-invalid"
                                    >Phone Type is required.</span
                                >
                            </div>
                            <div class="form-group col-12 col-lg-4 pe-lg-2">
                                <label for="referral-mobile-number"> Alternate Phone Number </label>
                                <PhoneNumber
                                    :enable-country="true"
                                    v-model:value="alternateNumber"
                                    v-model:extension="alternateExtension"
                                    v-model:type="alternateType"
                                    v-model:country="alternateCountry"
                                    :phone-type-options="phoneNumberTypeOptionsConfig"
                                    v-number-only
                                />
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label for="referral-email"> Email </label>
                                <input
                                    name="referral-email"
                                    class="form-control"
                                    maxlength="50"
                                    type="text"
                                    placeholder="Enter Email Address"
                                    v-model="patientDetails.demographics.email"
                                />
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label id="Referral_Agency_Branch_Label" for="agency-location-id">
                                    Agency Branch
                                    <span class="text-danger">*</span>
                                </label>
                                <select
                                    id="Referral_Agency_Branch"
                                    name="agency-location-id"
                                    class="form-select"
                                    v-model="patientDetails.demographics.locationId"
                                    @blur="v$.patientDetails.demographics.locationId.$touch"
                                    :class="`${
                                        v$.patientDetails.demographics.locationId.$error ? 'field-invalid' : ''
                                    }`"
                                    @change="(e) => handleAllInput(e, 'locationId')"
                                >
                                    <option :value="null">Select Branch</option>
                                    <option v-for="branch of branches" :value="branch.id" :key="branch.id">
                                        {{ branch.name }}
                                    </option>
                                </select>
                                <span v-if="v$.patientDetails.demographics.locationId.$error" class="field-invalid"
                                    >Agency Branch is required.</span
                                >
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label for="referral-marital-status"> Marital Status </label>
                                <select
                                    class="form-select"
                                    name="marital-status"
                                    v-model="patientDetails.demographics.maritalStatus"
                                >
                                    <option value="0">Select Marital Status</option>
                                    <option v-for="[key, value] of MaritalStatuses" :key="key" :value="value.value">
                                        {{ value.name }}
                                    </option>
                                </select>
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label for="referral-ethnicity"> Ethnicity <span class="text-danger">*</span> </label>
                                <select
                                    class="form-select"
                                    name="ethnicityPalliative"
                                    v-model="patientDetails.demographics.ethnicityOnly"
                                    :disabled="isEthnicityDeclined"
                                    @blur="v$.patientDetails.demographics.ethnicityOnly.$touch"
                                    :class="`${
                                        v$.patientDetails.demographics.ethnicityOnly.$error ? 'field-invalid' : ''
                                    }`"
                                    @change="(e) => handleAllInput(e, 'ethnicityOnly')"
                                >
                                    <option :value="null">Select Ethnicity</option>
                                    <option v-for="[key, value] of Ethnicity" :value="value.value" :key="key">
                                        {{ value.name }}
                                    </option>
                                </select>
                                <div class="form-check custom-checkbox pt-1">
                                    <input
                                        type="checkbox"
                                        class="form-check-input"
                                        id="decline-ethnicity"
                                        v-model="isEthnicityDeclined"
                                    />
                                    <label class="form-check-label" for="decline-ethnicity">Declines to Specify</label>
                                </div>
                                <span v-if="v$.patientDetails.demographics.ethnicityOnly.$error" class="field-invalid"
                                    >Ethnicity is required.</span
                                >
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label for="referral-race"> Race </label>
                                <TagsInput
                                    placeholder="Select Race"
                                    aria-autocomplete="off"
                                    :open-on-focus="true"
                                    :data="Races"
                                    :tags="selectedRaces"
                                    v-on:updateTags="updateSelectedRaces"
                                    :disabled="isRacesDeclined"
                                />
                                <div class="form-check custom-checkbox pt-1">
                                    <input
                                        type="checkbox"
                                        class="form-check-input"
                                        id="decline-race"
                                        v-model="isRacesDeclined"
                                    />
                                    <label class="form-check-label" for="decline-race">Declines to Specify</label>
                                </div>
                            </div>
                        </div>
                        <div class="w-100">
                            <p class="mb-2 d-flex align-items-center sub-heading">
                                <b class="me-2">Patient Primary Address</b>
                            </p>
                        </div>
                        <div>
                            <AddressForm
                                address-type="primaryAddress"
                                v-model:facility-id="patientDetails.demographics.primaryAddressFacilityTypeId"
                                v-model:address="patientDetails.demographics.primaryAddress"
                                :is-primary-address="true"
                                :reset-same-as-primary-address="resetSameAsPrimaryAddress"
                                :is-address-validation-in-progress="isAddressValidationInProgress"
                                :show-code="true"
                            />
                        </div>
                        <div class="col-12 d-flex align-items-center">
                            <div class="me-2">
                                <button
                                    class="btn btn-xs btn-primary mb-2"
                                    @click="validateAddress()"
                                    v-if="
                                        !patientDetails.demographics.primaryAddress.latitude &&
                                        !patientDetails.demographics.primaryAddress.longitude
                                    "
                                >
                                    Validate Patient Primary Address
                                </button>
                            </div>
                            <div>
                                <h6
                                    :class="`${
                                        patientDetails.demographics.primaryAddress.isBypassed
                                            ? 'text-warning'
                                            : 'text-danger'
                                    } fw-bold`"
                                    v-if="
                                        !patientDetails.demographics.primaryAddress.latitude &&
                                        !patientDetails.demographics.primaryAddress.longitude
                                    "
                                >
                                    <i class="fas fa-exclamation-triangle me-2"></i>
                                    <span
                                        >Address
                                        {{
                                            patientDetails.demographics.primaryAddress.isBypassed
                                                ? "Validation Bypassed"
                                                : "Not Validated"
                                        }}
                                    </span>
                                </h6>
                                <h6 class="text-success fw-bold" v-else>
                                    <i class="fas fa-check-circle"></i>
                                    <span> Address Validated </span>
                                </h6>
                            </div>
                        </div>

                        <div class="w-100">
                            <p class="mb-2 d-flex align-items-center sub-heading">
                                <b class="me-2">Patient Visit Address</b>
                            </p>
                        </div>
                        <div class="w-100">
                            <div class="form-check custom-checkbox form-check-inline">
                                <input
                                    type="checkbox"
                                    id="visit-same-primary-address"
                                    class="form-check-input au-target"
                                    v-model="visitAddrSameAsPrimaryAddr"
                                />
                                <label class="form-check-label" for="visit-same-primary-address">
                                    <span class="me-1">Same As Primary Address</span>
                                </label>
                            </div>
                        </div>
                        <AddressForm
                            v-if="!visitAddrSameAsPrimaryAddr"
                            address-type="visitAddress"
                            v-model:address="patientDetails.demographics.visitAddress"
                            :facility-id="patientDetails.demographics.visitAddressFacilityTypeId"
                        />

                        <div class="w-100 mt-3">
                            <p class="mb-2 d-flex align-items-center sub-heading">
                                <b class="me-2">Patient Mailing Address</b>
                            </p>
                        </div>
                        <div class="w-100">
                            <div class="form-check custom-checkbox form-check-inline">
                                <input
                                    type="checkbox"
                                    id="mailing-same-primary-address"
                                    class="form-check-input au-target"
                                    v-model="mailingAddrSameAsPrimaryAddr"
                                />
                                <label class="form-check-label" for="mailing-same-primary-address">
                                    <span class="me-1">Same As Primary Address</span>
                                </label>
                            </div>
                        </div>
                        <AddressForm
                            v-if="!mailingAddrSameAsPrimaryAddr"
                            address-type="mailingAddress"
                            v-model:address="patientDetails.demographics.mailingAddress"
                            :facility-id="patientDetails.demographics.mailingAddressFacilityTypeId"
                        />

                        <div class="w-100 mt-3">
                            <p class="mb-2 d-flex align-items-center sub-heading">
                                <b class="me-2">Patient Previous Address</b>
                            </p>
                        </div>
                        <div class="w-100">
                            <div class="form-check custom-checkbox form-check-inline">
                                <input
                                    type="checkbox"
                                    id="previous-same-primary-address"
                                    class="form-check-input au-target"
                                    v-model="patientDetails.demographics.hasPreviousAddress"
                                />
                                <label class="form-check-label" for="previous-same-primary-address">
                                    <span class="me-1">Has Previous Address</span>
                                </label>
                            </div>
                        </div>
                        <AddressForm
                            v-if="patientDetails.demographics.hasPreviousAddress"
                            address-type="previousAddress"
                            v-model:address="patientDetails.demographics.previousAddress"
                            :facility-id="patientDetails.demographics.previousAddressFacilityTypeId"
                            :show-move-date="true"
                        />

                        <div class="w-100 mt-3">
                            <p class="mb-2 d-flex align-items-center sub-heading">
                                <b class="me-2">CAHPS</b>
                            </p>
                        </div>
                        <div class="row">
                            <div class="form-group col-12 col-lg-4 pe-lg-2">
                                <label id="Referral_Cahps_Label" for="referral-Cahps"> CAHPS Survey </label>
                                <select
                                    id="Referral_Cahps"
                                    class="form-select"
                                    name="referral-Cahps"
                                    v-model="patientDetails.demographics.cahpsSurveyContactType"
                                >
                                    <option value="0">Receive CAHPS Survey</option>
                                    <option value="1">No Publicity</option>
                                </select>
                            </div>
                        </div>

                        <div class="w-100 mt-3">
                            <p class="mb-2 d-flex align-items-center sub-heading">
                                <b class="me-2">Languages</b>
                            </p>
                        </div>
                        <div class="row">
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label id="primary_language" for="primary_language"
                                    >Primary Language <span class="text-danger">*</span></label
                                >
                                <TypeaheadInput
                                    id="primary_language"
                                    :getData="getLanguagesFilter"
                                    :value="selectedLanguage"
                                    v-on:valueChanged="updateLanguage"
                                    :show-all-by-default="true"
                                    :open-on-focus="true"
                                    :init-value="selectedLanguage"
                                    placeholder="Enter Language"
                                    :disabled="patientDetails.demographics.declineToSpecifyLanguage"
                                    v-on:blurredInput="v$.patientDetails.demographics.primaryLanguage.$touch"
                                    :class="`${
                                        v$.patientDetails.demographics.primaryLanguage.$error ? 'field-invalid' : ''
                                    }`"
                                    @change="(e) => handleAllInput(e, 'primaryLanguage')"
                                ></TypeaheadInput>
                                <div class="form-check custom-checkbox pt-1">
                                    <input
                                        type="checkbox"
                                        class="form-check-input"
                                        id="decline-language"
                                        :checked="patientDetails.demographics.declineToSpecifyLanguage"
                                        @change="handleDeclineLanguage"
                                    />
                                    <label class="form-check-label" for="decline-language">Declines to Specify</label>
                                </div>
                                <span v-if="v$.patientDetails.demographics.primaryLanguage.$error" class="field-invalid"
                                    >Primary Language is required.</span
                                >
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label id="additional_language" for="additional_language"> Additional Language</label>
                                <TagsInput
                                    placeholder="Select other language"
                                    aria-autocomplete="off"
                                    :open-on-focus="true"
                                    :data="languagesList"
                                    :tags="selectedOtherLanguages"
                                    v-on:updateTags="updateSelectedOtherLanguages"
                                    :disabled="patientDetails.demographics.declineToSpecifyLanguage"
                                />
                            </div>
                            <div class="w-100"></div>
                            <div class="form-group col-12 col-lg-6 pe-lg-2">
                                <label id="Referral_First_Name_Label" for="referral-first-name">
                                    Auxiliary Aids Required</label
                                >
                                <input
                                    id="Referral_auxiliary_aid"
                                    name="referral-auxiliary_aid"
                                    class="form-control"
                                    maxlength="50"
                                    type="text"
                                    placeholder="Enter Type"
                                    v-model="patientDetails.demographics.auxiliaryAids"
                                />
                            </div>
                            <div class="form-group col-12 col-lg-12 pe-lg-2">
                                <label id="interpreter" for="interpreter"> Interpreter Required </label>
                                <div class="d-flex">
                                    <div v-for="interpreter of interpreters" :key="interpreter.value" class="me-4">
                                        <div
                                            :key="`${interpreter.value}-${interpreter.name}`"
                                            class="form-group form-check custom-checkbox"
                                        >
                                            <input
                                                type="checkbox"
                                                :id="`${interpreter.name}-${interpreter.value}`"
                                                class="form-check-input"
                                                :value="interpreter.value"
                                                :checked="
                                                    patientDetails.demographics.interpreter?.includes(interpreter.value)
                                                "
                                                v-model="patientDetails.demographics.interpreter"
                                            />
                                            <label
                                                class="form-check-label"
                                                :for="`${interpreter.name}-${interpreter.value}`"
                                            >
                                                {{ interpreter.name }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="form-group col-12 col-lg-4 px-lg-2"
                                    v-if="patientDetails.demographics.interpreter?.includes(8)"
                                >
                                    <label for="other-interpreter"> Other Interpreter Description </label>
                                    <input
                                        class="form-control"
                                        maxlength="50"
                                        name="other-interpreter"
                                        type="text"
                                        v-model="patientDetails.demographics.otherInterpreter"
                                        placeholder="Enter Interpreter"
                                    />
                                </div>
                            </div>
                            <div class="form-group col-12 col-lg-4 pe-lg-2">
                                <label for="referral-tags"> Tags</label>
                                <TagsInput
                                    id="referral-tags"
                                    placeholder="Start Typing..."
                                    :open-on-focus="true"
                                    :data="patientTags"
                                    :tags="selectedTags"
                                    v-on:updateTags="updateTags"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </template>
    </FormSection>
</template>

<script src="./DemographicsInformation.ts"></script>
